import React, { createContext, ReactElement, useState } from "react";

interface ModalTicketContextProviderProps {
  children: ReactElement;
}

interface ModalTicketContextProps {
  isModalOpen: boolean;
  toggleModal: () => void;
}

export const ModalTicketContext = createContext({} as ModalTicketContextProps);

export function ModalTicketContextProvider({
  children,
}: ModalTicketContextProviderProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  return (
    <ModalTicketContext.Provider value={{ isModalOpen, toggleModal }}>
      {children}
    </ModalTicketContext.Provider>
  );
}
